import React from "react";
import balineseImg from "./balinese-massage.jpg";   // ⭐ FIXED IMAGE PATH

const BalineseMassage = ({ setActiveSection }) => {
  return (
    <section className="bg-white text-gray-900">

      {/* ⭐ FULL PREMIUM BANNER —  STYLE */}
      <div className="relative w-full h-[350px] md:h-[450px]">

        {/* Background Image */}
        <img
          src={balineseImg}
          alt="Balinese Massage Banner"
          className="absolute inset-0 w-full h-full object-cover"
        />

        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/50"></div>

        {/* ⭐ CENTER TITLE */}
        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="text-4xl md:text-6xl font-bold text-white drop-shadow-lg">
            Balinese Massage
          </h1>
        </div>

        {/* ⭐ LEFT BOTTOM TITLE */}
        <div className="absolute bottom-0 left-0 bg-black/40 w-full py-4 px-6">
          <h2 className="text-xl md:text-2xl font-semibold text-white">
            Balinese Massage
          </h2>
        </div>

        {/* ⭐ RIGHT BOTTOM BREADCRUMB */}
        <div className="absolute bottom-0 right-0 bg-black/40 py-4 px-6 flex gap-2 text-white">
          <button
            onClick={() => setActiveSection("home")}
            className="hover:text-amber-300 transition"
          >
            Home
          </button>
          <span>›</span>
          <span className="text-amber-300">Balinese Massage</span>
        </div>
      </div>

      {/* ⭐ MAIN CONTENT ( Style Layout) */}
      <div className="container mx-auto px-4 py-20 grid md:grid-cols-2 gap-12 items-center">

        {/* LEFT IMAGE */}
        <div className="w-full">
          <img
            src={balineseImg}
            alt="Balinese Massage"
            className="rounded-2xl shadow-2xl w-full h-[500px] object-cover"
          />
        </div>

        {/* RIGHT DESCRIPTION */}
        <div>
          <h2 className="text-4xl md:text-5xl font-bold mb-8 text-amber-900 leading-tight">
            Experience True Balinese Healing
          </h2>

          <p className="text-gray-700 leading-relaxed mb-5 text-lg">
            Balinese Massage is a deeply relaxing and restorative treatment
            inspired by the traditional healing techniques of Bali. Using
            long, rhythmic strokes, gentle stretching, and aromatic essential
            oils, it helps balance the mind, body, and spirit.
          </p>

          <p className="text-gray-700 leading-relaxed mb-5 text-lg">
            This therapy improves blood circulation, releases tension,
            enhances flexibility, and restores energy flow throughout the body.
            Ideal for guests seeking relaxation with a touch of Indonesian
            wellness.
          </p>

          <p className="text-gray-700 leading-relaxed mb-5 text-lg">
            Whether you’re dealing with stress, fatigue, or emotional imbalance,
            our Balinese Massage offers a perfect blend of rejuvenation and
            calmness.
          </p>

          {/* ⭐ BOOK BUTTON ( Style) */}
          <button
            onClick={() => setActiveSection("booking")}
            className="bg-amber-900 text-white px-12 py-4 rounded-lg text-lg 
                       hover:bg-amber-800 transition-all hover:scale-105 shadow-xl"
          >
            Book Now
          </button>
        </div>

      </div>
    </section>
  );
};

export default BalineseMassage;
